import $ from 'jquery';
import _ from 'underscore';

"use strict";

var ViewCustomerService = Backbone.View.extend({

    initialize: function (opts) {
        
        console.log('init customer service');
        
        var self = this;
        self.$body = self.$el;
        // From page--customer-service--content-.liquid
        self.initCustomerService();
    },

    events: {
    },

    initCustomerService: function(){
        var self = this;

        // set up collapses

        var open = function ($el) {
            $el.height($el.data('height'));
    
            setTimeout(function () {
            $el.height('auto');
            $el.data('height', $el.height());
            $el.addClass('open')
            }, 300);
        }
    
        var close = function ($el) {
            $el.height($el.data('height'));
            $el.height('0px');
            
            setTimeout(function () {
            $el.removeClass('open')
            }, 300)
        }
    
        $('.is-collapsible .block-row-content').each(function () {
            var $el = $(this);
            $el.data('height', $el.height());
            close($el);
        })
    
        $('.is-collapsible .block-row').on('click', function () {
            close($('.block-row-content.open'));
    
            var $el = $(this).find('.block-row-content');
            $el.hasClass('open') ? close($el) : open($el);
        })
    
        // fix non-collapse label widths
    
        var labels = $('.not-collapsible .block-row-label');
        var widths = labels.map(function () { return $(this).width(); }).get()
        var width = Math.ceil(Math.max.apply(null, widths)) + 1 + 'px';
        
        labels.each(function () {
            $(this).css({
            maxWidth: width,
            width: '100%',
            });
        });
        
    },
    
    
});

export default ViewCustomerService;